<template>
    <div>
        <el-table :data="compare" border>
            <el-table-column label="修订项" prop="name"></el-table-column>
            <el-table-column label="修订后" prop="after">
                <template slot-scope="scope">
                    <span v-html="scope.row.after"></span>
                </template>
            </el-table-column>
            <el-table-column label="修改前" prop="before">
                <template slot-scope="scope">
                    <span v-html="scope.row.before"></span>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import order_contract from "~/views/order/partial/order_contract.vue";
    export default {
        components:{
            order_contract
        },
        name: "revise_contract",
        props:{
            order_edit:{
                required:true
            }
        },
        mounted(){
            this.compareContractNumber();
            this.compareContract();
            this.compareTime();
        },
        data(){
            return {
                compare:[],
                revise_order:{}
            }
        },
        methods:{
            compareTime(){
                let day = {
                    name: '合同上传时间',
                    before: '',
                    after: ''
                };
                let before = _.first(this.order_edit.before_content.contracts).created_at;
                let after =   _.first(this.order_edit.content.file_list).created_at;
                if(before !== after){
                    after = "<span style='color: red'>"+after+"</span>";
                }
                day.before = before;
                day.after = after;
                this.compare.push(day);
            },
            compareContract(){
                let day = {
                    name: '合同文件',
                    before: '',
                    after: ''
                };
                let before = "";
                this.order_edit.before_content.contracts.map(i=>{
                    before += '<a href='+i.url+' target="_blank"><i class="el-icon-document"></i>'+i.name+'</a><br/>';
                });
                let after =  "";
                this.order_edit.content.file_list.map(i=>{
                    after += '<a href='+i.url+' target="_blank"><i class="el-icon-document"></i>'+i.name+'</a><br/>';
                });
                if(before !== after){
                    after = "<span style='color: red'>"+after+"</span>";
                }
                day.before = before;
                day.after = after;
                this.compare.push(day);
            },
            compareContractNumber(){
                let day = {
                    name: '合同编号',
                    before: '',
                    after: ''
                };
                let before = this.order_edit.before_content.contract_number;
                let after =  this.order_edit.content.contract_number;
                if(before !== after){
                    after = "<span style='color: red'>"+after+"</span>";
                }
                day.before = before;
                day.after = after;
                this.compare.push(day);
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/order/recoder/revise_contract.vue